import React from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // resources,
    debug: true,
    load: "languageOnly",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: `translations/{{lng}}`,
    },
    // lng: 'en',
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
    lng: localStorage.getItem("i18nextLng") || "it",
    fallbackLng: "it",
    // prefix: "@@@", // {{
    // suffix: "@@@" // }}
  });

export default i18n;
